<section class="w-full h-full p-4 md:p-5">
  <div
    class="flex items-center justify-between gap-4 flex-wrap"
    *ngIf="view_schedules"
  >
    <div class="flex items-center gap-3">
      <h1 class="text-[20px] font-bold text-slate-800">
        {{ viewType === "monthly" ? "Monthly Scheduler" : "Weekly Planner" }}
      </h1>
    </div>
    <div class="flex items-center gap-3 flex-wrap">
      <button
        class="btn btn-sm border border-indigo-200 text-indigo-700 bg-white hover:bg-indigo-50"
        (click)="isAnalyticsView = !isAnalyticsView"
        *ngIf="view_analytics"
      >
        {{ isAnalyticsView ? "Close Analytics" : "Analytics" }}
      </button>
      <button
        class="btn btn-sm border-none bg-gradient-to-r from-blue-600 to-blue-700 text-white"
        (click)="openCreateForm()"
        *ngIf="create_schedule_event"
      >
        <i class="ri-add-line"></i> Create Class Schedule
      </button>
    </div>
  </div>

  <!-- search form -->
  <div class="mt-5 bg-white border border-slate-200 rounded-xl p-3 shadow-sm">
    <form [formGroup]="filterForm" (submit)="$event.preventDefault()">
      <div class="flex flex-wrap items-center gap-3">
        <select
          class="select select-sm select-bordered w-[140px] text-xs font-semibold"
          formControlName="department"
          (change)="setFields($event, 'department')"
        >
          <option selected [value]="null">Department</option>
          @if (departments && departments.length == 0) {
            <option disabled>No Departments</option>
          } @else {
            @for (i of departments || []; track $index) {
              <option class="text-base" [value]="i?.id">
                {{ i?.department_name }}
              </option>
            }
          }
        </select>

        <select
          class="select select-sm select-bordered w-[140px] text-xs font-semibold"
          formControlName="class"
          (change)="setFields($event, 'class')"
        >
          <option selected [value]="null">Class</option>
          @if (classes && classes.length == 0) {
            <option disabled>No Classes</option>
          } @else {
            @for (i of classes || []; track $index) {
              <option class="text-base" [value]="i?.id">
                {{ i?.class_name }}
              </option>
            }
          }
        </select>
        <select
          class="select select-sm select-bordered w-[140px] text-xs font-semibold"
          formControlName="batch"
        >
          <option selected [value]="null">Batch</option>
          @if (batches && batches.length == 0) {
            <option disabled>No Batches</option>
          } @else {
            @for (i of batches || []; track $index) {
              <option class="text-base" [value]="i?.id">
                {{ i?.batch_name }}
              </option>
            }
          }
        </select>
        <select
          class="select select-sm select-bordered w-[160px] text-xs font-semibold"
          formControlName="academic_year"
        >
          <option selected [value]="null">
            {{ viewType === "monthly" ? "Teacher" : "Academic Year" }}
          </option>
          @let academicYear = academicYear$ | async;
          @if (!academicYear?.data?.length) {
            <option disabled>No Academic Years</option>
          } @else {
            @for (i of academicYear.data || []; track $index) {
              <option class="text-base" [value]="i?.id">
                {{ i?.alias || i?.name }}
              </option>
            }
          }
        </select>

        <select
          class="select select-sm select-bordered w-[160px] text-xs font-semibold"
          formControlName="date_range"
          (change)="onDateRangeChange($any($event.target).value)"
        >

          <option value="today">Today</option>
          <option value="week">This week</option>
          <option value="month">This month</option>
          <option value="year">This year</option>
          <option value="customize">Customize date</option>
        </select>

        @if (filterForm.get('date_range')?.value === 'customize') {
          <div class="flex items-center gap-2">
            <input
              type="date"
              class="input input-sm input-bordered w-[160px] text-xs font-semibold"
              formControlName="customize_from"
            />
            <input
              type="date"
              class="input input-sm input-bordered w-[160px] text-xs font-semibold"
              formControlName="customize_to"
            />
          </div>
        }

        <button
          type="submit"
          class="btn btn-sm bg-slate-50 border border-slate-200"
          *ngIf="viewType === 'monthly'"
        >
          Apply Filter
        </button>

      </div>
    </form>
  </div>
  <!-- search form -->

  <!-- Analytics -->
  @if (isAnalyticsView) {
    <div>
      <div class="grid grid-cols-2 md:grid-cols-4 h-full gap-5 mt-5">
        @for (i of stats; track $index) {
          <a
            class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize"
          >
            <div class="relative z-[1] h-full flex flex-col justify-between">
              <p class="text-sm font-semibold text-zinc-500 capitalize">
                {{ i.title }}
              </p>
              <h2 class="text-4xl mt-2 font-bold">{{ i.count }}</h2>
            </div>
            <div class="absolute -bottom-8 -right-8">
              <span
                class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"
                ><i class="{{ i.icon }}"></i
              ></span>
            </div>
          </a>
        }
      </div>
    </div>
  }
  <!-- Analytics -->

  <!-- CALENDER -->
  @if (viewType === "monthly") {
    <div
      class="mt-5 bg-white border border-slate-200 rounded-xl p-4 shadow-[0_10px_30px_rgba(15,23,42,0.06)]"
    >
      <div class="mb-4">
        <div class="flex items-center justify-center gap-4 mb-3">
          <button
            class="border-0 bg-transparent text-2xl text-slate-500"
            (click)="shiftMonthlyDate(-1)"
          >
            <i class="ri-arrow-left-s-line"></i>
          </button>
          <h2 class="m-0 text-[32px] font-bold text-slate-600">
            {{ monthLabel }}
          </h2>
          <button
            class="border-0 bg-transparent text-2xl text-slate-500"
            (click)="shiftMonthlyDate(1)"
          >
            <i class="ri-arrow-right-s-line"></i>
          </button>
        </div>
        <div class="overflow-x-auto">
          <div
            class="grid grid-cols-[repeat(19,minmax(0,1fr))] gap-2 "
          >
            @for (day of monthDays; track $index) {
              <button
                class="w-full border border-slate-200 rounded-lg py-2 text-center cursor-pointer"
                [ngClass]="
                  day.active ? 'bg-green-500 border-green-500 text-white' : ''
                "
                (click)="selectMonthlyDate(day, $index)"
              >
                <strong class="block text-[20px]">{{ day.date }}</strong>
                <small class="text-xs opacity-80">{{ day.label }}</small>
              </button>
            }
          </div>
        </div>
      </div>

      <div class="grid grid-cols-[140px_1fr] gap-3">
        <div>
          @for (slot of timeSlots; track $index) {
            <div
              class="h-[96px] border-b border-slate-200 flex items-center text-[18px] font-medium text-slate-600"
            >
              {{ slot }}
            </div>
          }
        </div>

        <div
          class="relative grid grid-cols-4 auto-rows-[24px] gap-x-2.5 min-h-[576px]"
        >
          @for (slot of timeSlots; track $index; let slotIndex = $index) {
            @for (column of timelineColumns; track column) {
              <button
                type="button"
                class="border-0 border-b border-slate-200 bg-transparent cursor-pointer z-[1] hover:bg-blue-50/50"
                [style.gridColumn]="column + 1"
                [style.gridRow]="slotIndex * 4 + 1 + ' / span 4'"
                (click)="openCreateForSlot(slotIndex)"
                aria-label="Create schedule"
              ></button>
            }
          }

          @for (card of monthlyTimelineCards; track $index) {
            <div
              class="rounded-lg p-2 text-white shadow-[0_8px_18px_rgba(10,37,64,0.18)] z-[2] overflow-auto  flex flex-col min-h-0"
              [ngClass]="{
                'bg-[#11c70c]': card.colorClass === 'green',
                'bg-[#ff2a2f]': card.colorClass === 'red',
                'bg-[#248fd5]': card.colorClass === 'blue',
              }"
              [style.gridColumn]="card.column + 1"
              [style.gridRow]="card.row + 1 + ' / span ' + card.rowSpan"
              [style.minHeight.px]="card.rowSpan * 24 - 4"
              [style.width.%]="100 / (card.laneCount || 1)"
              [style.minWidth]="'0'"
              [style.boxSizing]="'border-box'"
            >
              <div
                class="flex items-center justify-between font-semibold shrink-0 text-xs"
              >
                <span class="text-[10px]">{{ card.timeRange }}</span>
                <div class="flex gap-1 items-center">
                  <button
                    type="button"
                    class="border-0 bg-transparent text-white p-0.5 leading-none cursor-pointer hover:bg-white/20 rounded"
                    (click)="openMonthlyCardView(card)"
                  >
                    <i class="ri-eye-line text-xs"></i>
                  </button>
                  <button
                    *ngIf="card.showActionButtons"
                    type="button"
                    class="border-0 bg-transparent text-white p-0.5 leading-none cursor-pointer hover:bg-white/20 rounded"
                    (click)="openMonthlyCardEdit(card)"
                  >
                    <i class="ri-pencil-line text-xs"></i>
                  </button>
                  <button
                    *ngIf="card.showActionButtons"
                    type="button"
                    class="border-0 bg-transparent text-white p-0.5 leading-none cursor-pointer hover:bg-white/20 rounded"
                    (click)="openMonthlyCardDelete(card)"
                  >
                    <i class="ri-delete-bin-line text-xs"></i>
                  </button>
                  <button
                    type="button"
                    class="border-0 bg-transparent text-white p-0.5 leading-none cursor-pointer hover:bg-white/20 rounded"
                    (click)="openAnalyticsModal(card, card.originalEvent)"
                  >
                    <i class="ri-file-list-3-line text-xs"></i>
                  </button>
                </div>
              </div>
              <div class="my-1 font-semibold leading-tight break-words text-xs">
                {{ card.title }}
              </div>
              <div class="leading-tight text-xs">
                Teacher: {{ card.teacher }}
              </div>
              <div class="leading-tight text-xs">
                Class: {{ card.className }}
              </div>
              <div class="leading-tight text-xs mt-0.5 flex-1 overflow-hidden">
                @if (card.rowSpan >= 8) {
                  <div>Parameters:</div>
                  <div class="overflow-y-auto max-h-full pr-1scrollbar-thin scrollbar-thumb-white/40 scrollbar-track-transparent">
                    @for (p of card.parameters; track $index) {
                      <div
                        class="leading-tight cursor-pointer hover:underline"
                        (click)="
                          $index === 3
                            ? openAnalyticsModal(card, card.originalEvent)
                            : null
                        "
                      >
                        {{ p }}
                      </div>
                    }
                  </div>
                } @else if (card.rowSpan >= 4) {
                  <div>
                    Parameters: {{ card.parameters.slice(0, 2).join(", ") }}
                  </div>
                } @else {
                  <div>Params: {{ card.parameters[0] }}</div>
                }
              </div>
              <div
                class="flex items-center justify-end gap-1 mt-1"
                *ngIf="card.showActionButtons"
              >
                <button
                  type="button"
                  class="bg-white/90 my text-slate-700 border-0 text-[8px] rounded px-1 py-0.5 hover:bg-white"
                  (click)="openMarkCompleteModal(card)"
                >
                  Mark as Complete
                </button>
              </div>
            </div>
          }

          @if (monthlyTimelineCards.length === 0) {
            <div
              class="col-span-2 self-center justify-self-center text-slate-500 text-base mt-6"
            >
              No events for {{ selectedDate | date: "d MMM yyyy" }}
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div
      class="weekly-planner mt-5 bg-white border border-slate-200 rounded-xl p-4 shadow-[0_10px_30px_rgba(15,23,42,0.06)]"
    >
      <div class="weekly-header">
        <div>
          <h2 class="weekly-title">Weekly Planner</h2>
        </div>
        <!-- <div class="weekly-actions">
          <button
            type="button"
            class="btn btn-sm bg-blue-600 border-blue-600 text-white"
            (click)="openCreateForm()"
            *ngIf="create_schedule_event"
          >
            + Create Weekly Schedule
          </button>
          <button
            type="button"
            class="btn btn-sm bg-red-600 border-red-600 text-white"
          >
            Clear Weekly Schedule
          </button>
        </div> -->
      </div>

      <div class="weekly-month-nav">
        <button
          type="button"
          class="weekly-nav-btn"
          (click)="shiftWeeklyMonth(-1)"
        >
          <i class="ri-arrow-left-s-line"></i>
        </button>
        <span class="weekly-month-label">{{
          weeklyDate | date: "MMMM yyyy"
        }}</span>
        <button
          type="button"
          class="weekly-nav-btn"
          (click)="shiftWeeklyMonth(1)"
        >
          <i class="ri-arrow-right-s-line"></i>
        </button>
      </div>

      <div class="weekly-tabs">
        @for (tab of weeklyTabs; track $index) {
          <button
            type="button"
            class="weekly-tab cursor-auto"
            [ngClass]="tab === activeWeeklyTab ? 'active' : ''"
          >
            {{ tab }}
          </button>
        }
      </div>

      <div class="weekly-calendar">
        @if (calendarApp) {
          <sx-calendar [calendarApp]="calendarApp"></sx-calendar>
        } @else {
          <div class="flex items-center justify-center h-64">
            <app-loader></app-loader>
          </div>
        }
      </div>
    </div>
  }
  <!-- CALENDER -->

  <!-- drawer -->

  <app-schedule-drawer-control></app-schedule-drawer-control>

  <!-- drawer -->

  @if (isAnalyticsModalOpen && selectedAnalyticsEvent) {
    <div
      class="fixed inset-0 bg-slate-900/35 flex justify-center items-start p-6 z-[70]"
      (click)="closeAnalyticsModal()"
    >
      <div
        class="w-[min(760px,96vw)] max-h-[92vh] overflow-auto bg-white rounded-lg p-5 md:p-6 relative"
        (click)="$event.stopPropagation()"
      >
        <button
          class="absolute right-3.5 top-3 border-0 bg-transparent text-[22px] text-slate-800 cursor-pointer"
          (click)="closeAnalyticsModal()"
        >
          <i class="ri-close-line"></i>
        </button>
        <h1 class="text-[20px] font-extrabold text-[#093047] mb-4">
          Analytics
        </h1>

        <div class="mb-3">
          <p class="text-sm font-bold text-slate-800 mb-1">Course</p>
          <p class="m-0 text-[20px] leading-none text-slate-900">
            {{ selectedAnalyticsEvent.course }}
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Date</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedAnalyticsEvent.date | date: "d MMMM yyyy" }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Time</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedAnalyticsEvent.time | date: "hh:mm a" }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Teacher</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedAnalyticsEvent.teacher }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Class</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedAnalyticsEvent.className }}
            </p>
          </div>
        </div>

        <div class="mt-4">
          <p class="text-sm font-bold text-slate-800 mb-1">Description</p>
          <p class="m-0 text-[20px] leading-none text-slate-800">
            {{ selectedAnalyticsEvent.description }}
          </p>
        </div>

        <h3
          class="mt-5 mb-2.5 text-[20px] font-extrabold text-[#08364e] underline"
        >
          Remarks by Teacher
        </h3>
        <div>
          @for (item of selectedAnalyticsEvent.teacherRemarks; track $index) {
            <div
              class="grid grid-cols-1 md:grid-cols-[150px_120px_1fr] gap-2.5 items-center mb-2"
            >
              <div class="text-[20px] text-slate-900">{{ item.label }}</div>
              <div class="flex gap-2.5 text-base text-slate-400">
                <label
                  ><input
                    type="radio"
                    class="mr-1"
                    [checked]="item.yes"
                    disabled
                  />Yes</label
                >
                <label
                  ><input
                    type="radio"
                    class="mr-1"
                    [checked]="!item.yes"
                    disabled
                  />No</label
                >
              </div>
              <input
                class="w-full border border-slate-300 rounded-sm px-2.5 py-1.5 text-base text-slate-700"
                [value]="item.note"
                readonly
              />
            </div>
          }
        </div>

        <h3
          class="mt-5 mb-2.5 text-[20px] font-extrabold text-[#08364e] underline"
        >
          Remarks by Student
        </h3>
        @for (
          studentRemark of showAllStudentRemarks
            ? selectedAnalyticsEvent.studentRemarks
            : selectedAnalyticsEvent.studentRemarks.slice(0, 2);
          track $index
        ) {
          <div class="mb-2.5">
            <p class="text-[20px] font-bold text-slate-800 my-2">
              {{ studentRemark.student }}
            </p>
            <div class="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-3">
              <div class="pt-1">
                @for (row of studentRemark.rows; track $index) {
                  <div class="flex justify-between text-sm leading-[1.4]">
                    <span>{{ row.label }}</span>
                    <strong
                      [ngClass]="
                        row.value === 'No' ? 'text-red-600' : 'text-slate-700'
                      "
                      >{{ row.value }}</strong
                    >
                  </div>
                }
              </div>
              <textarea
                class="w-full min-h-[90px] border border-slate-300 rounded-sm px-2.5 py-2 text-base text-slate-800 resize-none"
                readonly
                >{{ studentRemark.note }}</textarea
              >
            </div>
          </div>
        }

        @if (selectedAnalyticsEvent.studentRemarks.length > 2) {
          <div class="flex justify-end">
            <button
              class="border-0 bg-transparent text-blue-500 text-base cursor-pointer"
              (click)="showAllStudentRemarks = !showAllStudentRemarks"
            >
              {{ showAllStudentRemarks ? "Show less..." : "Show more..." }}
            </button>
          </div>
        }
      </div>
    </div>
  }

  @if (isReqSend) {
    <div>
      <app-loader></app-loader>
    </div>
  }

  @if (isMarkCompleteModalOpen && selectedMarkCompleteEvent) {
    <div
      class="fixed inset-0 bg-slate-900/35 flex justify-center items-start p-6 z-[80]"
      (click)="closeMarkCompleteModal()"
    >
      <div
        class="w-[min(760px,96vw)] max-h-[92vh] overflow-auto bg-white rounded-lg p-5 md:p-6 relative"
        (click)="$event.stopPropagation()"
      >
        <button
          class="absolute right-3.5 top-3 border-0 bg-transparent text-[22px] text-slate-800 cursor-pointer"
          (click)="closeMarkCompleteModal()"
        >
          <i class="ri-close-line"></i>
        </button>

        <h1 class="text-[20px] font-extrabold text-[#093047] mb-4">
          Mark as Complete
        </h1>

        <div class="mb-3">
          <p class="text-sm font-bold text-slate-800 mb-1">Course</p>
          <p class="m-0 text-[20px] leading-none text-slate-900">
            {{ selectedMarkCompleteEvent.course }}
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Date</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedMarkCompleteEvent.date | date: "d MMMM yyyy" }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Time</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedMarkCompleteEvent.time | date: "hh:mm a" }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Teacher</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedMarkCompleteEvent.teacher }}
            </p>
          </div>
          <div>
            <p class="text-sm font-bold text-slate-800 mb-1">Class</p>
            <p class="m-0 text-[20px] leading-none text-slate-900">
              {{ selectedMarkCompleteEvent.className }}
            </p>
          </div>
        </div>

        <div class="mt-4">
          <p class="text-sm font-bold text-slate-800 mb-1">Description</p>
          <p class="m-0 text-[20px] leading-none text-slate-800">
            {{ selectedMarkCompleteEvent.description }}
          </p>
        </div>

        <h3
          class="mt-5 mb-2.5 text-[20px] font-extrabold text-[#08364e] underline"
        >
          Remarks
        </h3>
        @for (item of selectedMarkCompleteEvent.remarks; track $index) {
          <div
            class="grid grid-cols-1 md:grid-cols-[150px_120px_1fr] gap-2.5 items-center mb-2"
          >
            <div class="text-[20px] text-slate-900">{{ item.label }}</div>
            <div class="flex gap-2.5 text-base text-slate-400">
              <label>
                <input
                  type="radio"
                  class="mr-1"
                  name="mark-{{ $index }}"
                  [checked]="item.yes"
                  (change)="updateRemarkYes($index, true)"
                />Yes
              </label>
              <label>
                <input
                  type="radio"
                  class="mr-1"
                  name="mark-{{ $index }}"
                  [checked]="!item.yes"
                  (change)="updateRemarkYes($index, false)"
                />No
              </label>
            </div>
            <input
              class="w-full border border-slate-300 rounded-sm px-2.5 py-1.5 text-base text-slate-700"
              [value]="item.note"
              (input)="updateRemarkNote($index, $event)"
              placeholder="Add remark"
            />
          </div>
        }

        <div class="flex justify-end gap-2 mt-3">
          <button
            type="button"
            class="btn btn-sm bg-sky-500 border-sky-500 text-white"
            (click)="saveMarkComplete()"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-sm bg-slate-200 border-slate-200 text-slate-700"
            (click)="closeMarkCompleteModal()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  }
</section>
